<template>
  <!-- 设备信息 -->
  <div class="deviceinfo">
    <!-- :data="deviceInfo" -->

    <!-- ========================== -->
    <!-- <span style="color:#fff;">{{deviceInfo}}</span> -->
    <!-- ========================== -->
    <div v-if="deviceFlag" class="infobox" :style="{ gridTemplateAreas: gridAreas }">
      <!-- 基本信息 -->
      <div class="title gTitle1">{{ `1.${$t('datalogger.basic_info')}` }}</div>
      <div class="cell name light gCell11 splitHLine">{{ $t('device.device_sn') }}</div>
      <div class="cell data dark gCell12 splitHLine">{{ deviceInfo.deviceSn||deviceInfo.sn }}</div>
      <div class="gCell01 splitVBox"></div>
      <div class="cell name light gCell13 splitHLine">{{ $t('device.device_model') }}</div>
      <div class="cell data dark gCell14 splitHLine">{{ deviceInfo.devtype || '--' }}</div>
      <div class="cell name light gCell21 splitHLine">{{ $t('datalogger.Firmware_Version') }}</div>
      <div class="cell data dark gCell22 splitHLine">{{ deviceInfo.device_Firmware_Version || '--' }}</div>
      <div class="gCell02 splitVBox"></div>
      <div class="cell name light gCell23 splitHLine">{{ $t('device.device_code') }}</div>
      <div class="cell data dark gCell24 splitHLine">{{ deviceInfo.devcode }}</div>
      <!-- 所属数采器 -->
      <div class="title gTitle2">
        {{ `2.${$t('device.Datalogger_belong')}` }}
        <el-button class="todetail" @click="showDetail">
          {{ $t('device.detail') }}
        </el-button>
      </div>
      <div class="cell name light gCell41">{{ $t('device.coll_alias') }}</div>
      <div class="cell data dark gCell42">{{ deviceInfo.collalias }}</div>
      <div class="gCell04 splitVBox"></div>
      <div class="cell name light gCell43">{{ $t('device.datalogger_pn') }}</div>
      <div class="cell data dark gCell44">{{ deviceInfo.pn }}</div>
      <!-- 收益信息 -->
      <div class="title gTitle3">{{ `3.${$t('datalogger.income_info')}` }}</div>
      <div class="cell name light gCell51 splitHLine">{{ `${$t('device.Today_income')}` }}</div>
      <div class="cell data dark gCell52 splitHLine">{{ deviceInfo.profitToday | formatNum(2) }}</div>
      <div class="gCell05 splitVBox"></div>
      <div class="cell name light gCell53 splitHLine">{{ `${$t('device.Cumulative_income')}` }}</div>
      <div class="cell data dark gCell54 splitHLine">{{ deviceInfo.profitTotal | formatNum(2) }}</div>
      <div class="cell name light gCell61 splitHLine">{{ `${$t('device.buyProfit_Today')}` }}</div>
      <div class="cell data dark gCell62 splitHLine">{{ deviceInfo.buyProfitToday | formatNum(2) }}</div>
      <div class="gCell05 splitVBox"></div>
      <div class="cell name light gCell63 splitHLine">{{ `${$t('device.buyProfit_Total')}` }}</div>
      <div class="cell data dark gCell64 splitHLine">{{ deviceInfo.buyProfitTotal | formatNum(2) }}</div>
      <div class="cell name light gCell71 splitHLine">{{ `${$t('device.sellProfit_Today')}` }}</div>
      <div class="cell data dark gCell72 splitHLine">{{ deviceInfo.sellProfitToday | formatNum(2) }}</div>
      <div class="gCell05 splitVBox"></div>
      <div class="cell name light gCell73 splitHLine">{{ `${$t('device.sellProfit_Total')}` }}</div>
      <div class="cell data dark gCell74 splitHLine">{{ deviceInfo.sellProfitTotal | formatNum(2) }}</div>
    </div>
    <div v-else class="infobox">
      <!-- 基本信息 -->
      <div class="title gTitle1">{{ `1.${$t('datalogger.basic_info')}` }}</div>
      <div class="cell name light gCell11 splitHLine">{{ $t('device.device_sn') }}</div>
      <div class="cell data dark gCell12 splitHLine">{{ deviceInfo.deviceSn||deviceInfo.sn }}</div>
      <div class="gCell01 splitVBox"></div>
      <div class="cell name light gCell13 splitHLine">{{ $t('device.device_type') }}</div>
      <div class="cell data dark gCell14 splitHLine">{{ deviceInfo.brand | translateDeviceType }}</div>
      <div class="cell name light gCell21 splitHLine">{{ $t('device.device_model') }}</div>
      <div class="cell data dark gCell22 splitHLine">{{ deviceInfo.devtype || '--' }}</div>
      <div class="gCell02 splitVBox"></div>
      <div class="cell name light gCell23 splitHLine">{{ $t('device.device_code') }}</div>
      <div class="cell data dark gCell24 splitHLine">{{ deviceInfo.devcode }}</div>
      <div class="cell name light gCell31">{{ $t('datalogger.Firmware_Version') }}</div>
      <div class="cell data dark gCell32">{{ deviceInfo.device_Firmware_Version || '--' }}</div>
      <div class="gCell03 splitVBox"></div>
      <div class="cell name light gCell33">{{ $t('device.device_address') }}</div>
      <div class="cell data dark gCell34">{{ deviceInfo.devaddr }}</div>
      <!-- 所属数采器 -->
      <div class="title gTitle2">
        {{ `2.${$t('device.Datalogger_belong')}` }}
        <el-button class="todetail" @click="showDetail">
          {{ $t('device.detail') }}
        </el-button>
      </div>
      <div class="cell name light gCell41">{{ $t('device.coll_alias') }}</div>
      <div class="cell data dark gCell42">{{ deviceInfo.collalias }}</div>
      <div class="gCell04 splitVBox"></div>
      <div class="cell name light gCell43">{{ $t('device.datalogger_pn') }}</div>
      <div class="cell data dark gCell44">{{ deviceInfo.pn }}</div>
      <!-- 收益信息 -->
      <div class="title gTitle3">{{ `3.${$t('datalogger.income_info')}` }}</div>
      <div class="cell name light gCell51 splitHLine">{{ `${$t('device.Today_income')}` }}</div>
      <div class="cell data dark gCell52 splitHLine">{{ deviceInfo.profitToday | formatNum(2) }}</div>
      <div class="gCell05 splitVBox"></div>
      <div class="cell name light gCell53 splitHLine">{{ `${$t('device.Cumulative_income')}` }}</div>
      <div class="cell data dark gCell54 splitHLine">{{ deviceInfo.profitTotal | formatNum(2) }}</div>
      <div class="cell name light gCell61 splitHLine">{{ `${$t('device.buyProfit_Today')}` }}</div>
      <div class="cell data dark gCell62 splitHLine">{{ deviceInfo.buyProfitToday | formatNum(2) }}</div>
      <div class="gCell05 splitVBox"></div>
      <div class="cell name light gCell63 splitHLine">{{ `${$t('device.buyProfit_Total')}` }}</div>
      <div class="cell data dark gCell64 splitHLine">{{ deviceInfo.buyProfitTotal | formatNum(2) }}</div>
      <div class="cell name light gCell71 splitHLine">{{ `${$t('device.sellProfit_Today')}` }}</div>
      <div class="cell data dark gCell72 splitHLine">{{ deviceInfo.sellProfitToday | formatNum(2) }}</div>
      <div class="gCell05 splitVBox"></div>
      <div class="cell name light gCell73 splitHLine">{{ `${$t('device.sellProfit_Total')}` }}</div>
      <div class="cell data dark gCell74 splitHLine">{{ deviceInfo.sellProfitTotal | formatNum(2) }}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      // 显示数采器页
      showDevicebelong: false,
      deviceFlag:JSON.parse(sessionStorage.getItem('vcodes')||[]).some(item => item === "08"),
      // 设备信息
      // deviceOwnInfo: {
      //   // brand: "",
      //   // collalias: "",
      //   // devaddr: "",
      //   // devalias: "",
      //   // devcode: "",
      //   // devtype: "",
      //   // pid: "",
      //   // pn: "",
      //   // profitToday: "",
      //   // profitTotal: "",
      //   // sn: "",
      //   // status: "",
      //   // uid: "",
      //   // usr: "",
      // }
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
    gridAreas() {
      if (this.deviceFlag) {
        return `
          'a1 a1 a1 a1 a1'
          'a11 a12 s1 a13 a14'
          'a21 a22 s2 a23 a24'
          'a2 a2 a2 a2 a2'
          'a41 a42 s4 a43 a44'
          'a3 a3 a3 a3 a3'
          'a51 a52 s5 a53 a54'
          'a61 a62 s5 a63 a64'
          'a71 a72 s5 a63 a74'
        `;
      } else {
        return `
          'a1 a1 a1 a1 a1'
          'a11 a12 s1 a13 a14'
          'a21 a22 s2 a23 a24'
          "a31 a32 s3 a33 a34"
          'a2 a2 a2 a2 a2'
          'a41 a42 s4 a43 a44'
          'a3 a3 a3 a3 a3'
          'a51 a52 s5 a53 a54'
          'a61 a62 s5 a63 a64'
          'a71 a72 s5 a63 a74'
        `;
      }
    }
  },
  // created() {
  //   this.getDeviceOwnInfo();
  // },
  methods: {
    showDetail () {
      this.$emit('showdetail', true);
    },
    // 获取设备信息
    // getDeviceOwnInfo() {
    //   let param = {
    //     sn: this.deviceInfo.sn,
    //     // devtype: 2304,
    //   };
    //   this.$request.get("webQueryDeviceEs", param).then(res => {
    //     if (res.err == 0) {
    //       // console.log('getDeviceInfo', res.dat.device[0]);
    //       this.deviceOwnInfo = res.dat.device[0];
    //     } else {
    //       this.$message.warning(this.$t(`errCode.${res.err}`));
    //     }
    //   });
    // },
  }
}
</script>
<style lang="less" scoped>
.deviceinfo {
  // width: 500px;
  width: 100%;
  // box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);

  .infobox {
    display: grid;
    grid-template-columns: 1fr 1fr 4px 1fr 1fr;
    // grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    // grid-template-columns: 100px 100px 100px 100px;
    grid-template-rows: 56px 56px 56px 56px 56px 56px 56px 56px;
    grid-template-areas:
      "a1 a1 a1 a1 a1"
      "a11 a12 s1 a13 a14"
      "a21 a22 s2 a23 a24"
      "a31 a32 s3 a33 a34"
      "a2 a2 a2 a2 a2"
      "a41 a42 s4 a43 a44"
      "a3 a3 a3 a3 a3"
      "a51 a52 s5 a53 a54"
      "a61 a62 s5 a63 a64"
      "a71 a72 s5 a63 a74"
    ;

    // ......................
    .gTitle1 {
      grid-area: a1;
    }

    .gCell11 {
      grid-area: a11;
    }

    .gCell12 {
      grid-area: a12;
    }

    .gCell13 {
      grid-area: a13;
    }

    .gCell14 {
      grid-area: a14;
    }

    // 
    .gCell21 {
      grid-area: a21;
    }

    .gCell22 {
      grid-area: a22;
    }

    .gCell23 {
      grid-area: a23;
    }

    .gCell24 {
      grid-area: a24;
    }

    // 
    .gCell31 {
      grid-area: a31;
    }

    .gCell32 {
      grid-area: a32;
    }

    .gCell33 {
      grid-area: a33;
    }

    .gCell34 {
      grid-area: a34;
    }

    // ......................
    .gTitle2 {
      grid-area: a2;
    }

    .gCell41 {
      grid-area: a41;
    }

    .gCell42 {
      grid-area: a42;
    }

    .gCell43 {
      grid-area: a43;
    }

    .gCell44 {
      grid-area: a44;
    }

    // ......................
    .gTitle3 {
      grid-area: a3;
    }

    .gCell51 {
      grid-area: a51;
    }

    .gCell52 {
      grid-area: a52;
    }

    .gCell53 {
      grid-area: a53;
    }

    .gCell54 {
      grid-area: a54;
    }

    // 分割竖盒
    .gCell01 {
      grid-area: s1;
    }

    .gCell02 {
      grid-area: s2;
    }

    .gCell03 {
      grid-area: s3;
    }

    .gCell04 {
      grid-area: s4;
    }

    .gCell05 {
      grid-area: s5;
    }

    // ......................
    .title {
      line-height: 56px;
      padding: 0px 20px;
      background: rgba(65, 80, 90, 1);
      color: rgba(235, 235, 235, 1);
      font-weight: bold;
      font-size: 16px;
      position: relative;
    }

    .cell {
      display: flex;
      align-items: center;
      line-height: 24px;
      padding: 0px 16px;
      box-shadow: none;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      // overflow-y: scroll;
      height: 56px;
      // line-height: 56px;
      // padding: 0px 16px;
      // // box-shadow: -1px 0px rgba(198, 209, 221, 0.5) inset;
      // box-shadow: none;
      // color: rgba(255, 255, 255, 0.8);
      // font-size: 14px;
      // width: 50%;
      // .celltxt {
      //   display: inline-block;
      //   // width: 100%;
      //   text-overflow:ellipsis;
      //   overflow:hidden;
      //   white-space:nowrap;
      // }
    }

    // 信息表格分割系列=====
    // 分割横线H
    .splitHLine {
      border-bottom: 1px solid rgba(198, 209, 221, 0.3);
    }

    // 分割竖线V
    // .splitVLine {
    //   border-bottom: 1px solid rgba(198,209,221,0.3);
    // }
    // 分割竖盒VBox
    .splitVBox {
      width: 4px;
      height: 100%;
      background: #222d35;
      border-left: 1px solid rgba(198, 209, 221, 0.3);
      border-right: 1px solid rgba(198, 209, 221, 0.3);
    }

    // .name {}
    .data {
      // display: inline-block;
      // text-overflow: ellipsis;
      // overflow: hidden;
      // white-space: nowrap;
    }

    .dark {
      background: rgb(34, 45, 53);
    }

    .light {
      background: rgb(43, 56, 66);
    }

    .todetail {
      padding: 8px 12px;
      border: none;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      font-size: 14px;
      position: absolute;
      top: 13px;
      right: 12px;
      z-index: 1;
    }
  }
}</style>